// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3x-1";
export var movingGradient = "_3x-4";
export var movingGradientBlock = "_3x-2";
export var skeleton = "_3x-0";
export var skeletonText = "_3x-3";